import React from "react"
import { IQuote } from "@/types/quotes.types"
import KosmoNetworkDeliveryOptionCard from "./KosmoNetworkDeliveryOptionCard"
import { ServerDeliveryType } from "@/types/deliveryTypes.types"
import KosmoNetworkDeliveryOptionCardCompact from "./KosmoNetworkDeliveryOptionCardCompact"
import { isEmpty } from "lodash"
import { useTranslation } from "react-i18next"

interface KosmoNetworkDeliveryOptionsProps {
  quotes: IQuote[]
  selectedQuote: IQuote | null | undefined
  onSelect: (selectedQuote: IQuote | null) => Promise<void>
  displayType: "compact" | "full"
  selectionDisabled?: boolean
}

const KosmoNetworkDeliveryOptions: React.FC<KosmoNetworkDeliveryOptionsProps> = ({
  quotes,
  selectedQuote,
  onSelect,
  displayType = "full",
  selectionDisabled,
}) => {
  const { t } = useTranslation()

  const sortingArray = [
    ServerDeliveryType.INSTANT,
    ServerDeliveryType.FOURHOURS,
    ServerDeliveryType.NEXT_DAY,
    ServerDeliveryType.NEXT_THREE_DAYS,
  ]

  return (
    <div className="flex flex-col gap-y-2">
      {isEmpty(quotes) ? (
        <p className="font-medium max-w-[360px] text-center">
          {t("common.notification.noQuoteResultsDetails")}
        </p>
      ) : (
        quotes
          .sort(
            (a, b) => sortingArray.indexOf(a.deliveryType) - sortingArray.indexOf(b.deliveryType)
          )
          .map((quote) => (
            <>
              {displayType === "full" ? (
                <KosmoNetworkDeliveryOptionCard
                  quote={quote}
                  selectedQuote={selectedQuote}
                  onSelect={onSelect}
                  selectionDisabled={selectionDisabled}
                />
              ) : (
                <KosmoNetworkDeliveryOptionCardCompact
                  quote={quote}
                  selectedQuote={selectedQuote}
                  onSelect={onSelect}
                  selectionDisabled={selectionDisabled}
                />
              )}
            </>
          ))
      )}
    </div>
  )
}

export default KosmoNetworkDeliveryOptions
